import { registerSW } from 'virtual:pwa-register';

export function initSWAutoUpdate() {
  registerSW({
    immediate: true,
    onRegisteredSW(swUrl, registration) {
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 5 * 60 * 1000); // check for updates every 5 minutes
      }
    },
  });
}

export default initSWAutoUpdate;
